import config from '../../../config.json'
import { generateUrl } from '../../utils'
import { newsDisplayedPubDate } from '../../utils/news'

export function SchemaMarkupNews({ news }) {
    const mainImage =
        news?.thumbnail?.file?.hash &&
        `/api/filedb/${news.thumbnail.file.hash}.${news.thumbnail.file?.ext}`
    let author = ''
    if (news.reporter) {
        author = `"author": {
            "@type": "Person",
            "givenName": "${news.reporter.first_name}",
            "familyName": "${news.reporter.last_name}",
            "url": "${config.core.rootUrl}${generateUrl(news.reporter, 'user')}"
        }`
    } else if (news.author) {
        author = `"author": {
            "@type": "Person",
            "name": "${news.author}"
        }`
    } else {
        author = `"author": {
            "@type": "Organization",
            "name": "${config.core.organization}"
        }`
    }
    const reference = news.reference ?
        `"sourceOrganization":{
        "@type":"Organization",
        "name":"${news.reference.title}"
        },` : ''
    return <script
        id="newsschema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
            __html: `{
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "${config.core.rootUrl}${generateUrl(news, 'news')}"
            },
            "headline": "${news.title.replace(/"/g, '\\"')}",
            ${mainImage
                    ? `"image": "${config.core.rootUrl}/_next/image?url=${encodeURIComponent(
                        mainImage
                    )}&w=1200&q=75",`
                    : ''
                }
            "datePublished": "${newsDisplayedPubDate(news, 'iso')}",
            "dateModified": "${newsDisplayedPubDate(news, 'iso')}",
            ${author},
            ${reference}
            "publisher": {
                "@type": "Organization",
                "name": "${config.core.organization}",
                "logo": {
                "@type": "ImageObject",
                "url": "${config.core.rootUrl}/img/project/logo.png"
                }
            },
            "description": "${news.abst?.replace(/"/g, '\\"')}"
        }`,
        }}
    />
}